export const TB_ASSISTANT_BASE_URL = 'https://prestable.api-ui.toloka-test.ai/api/tb-assistant';
// export const TB_ASSISTANT_BASE_URL = 'http://localhost:8000/api/tb-assistant';
